/**
 * @module experience/shop/cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import {
  Cart,
  CartLine,
  CartItem,
  AccessoriesTotal,
  Pricing,
  AccessoriesByQuantity,
  Payment,
} from '@support/api/proxies/responses/api-cart-response.interface';

export class ShoppingCart implements Cart {
  public accessories: CartItem[];
  public cartId: string;
  public accessoriesEipEligible: boolean;
  public extCartId: string;
  public accessoriesTotal: AccessoriesTotal[];
  public lines: CartLine[];
  public devices: CartItem[];
  public rateplan: CartItem;
  public services: CartItem[];
  public pricing: Pricing;
  public payment: Payment[];
  public accessoriesByQuantity: AccessoriesByQuantity[];

  constructor() {
    const pricing: Pricing = undefined;
    const rateplan: CartItem = undefined;
    this.accessories = [];
    this.cartId = '';
    this.accessoriesEipEligible = false;
    this.extCartId = '';
    this.accessoriesTotal = [];
    this.lines = [];
    this.devices = [];
    this.rateplan = rateplan;
    this.services = [];
    this.pricing = pricing;
    this.accessoriesByQuantity = [];
    this.payment = [];
  }
}
